export type RenderProps =
  | {
      children: React.ReactNode;
      component?: undefined;
      render?: undefined;
    }
  | {
      children?: undefined;
      component: React.ComponentType<Record<string, never>>;
      render?: undefined;
    }
  | {
      children?: undefined;
      component?: undefined;
      render?: () => React.ReactNode;
    };

export function Render({
  children,
  component: Component,
  render,
}: RenderProps) {
  if (children) {
    return children;
  } else if (Component) {
    return <Component />;
  } else if (render) {
    return render();
  }
  return null;
}
